import { serviceInstance as api } from "../service";

export const getOrders = async (params) => {

  const queryParams = new URLSearchParams({
    fechaInicioPedido: params.fechaInicioPedido.replace(/-/g, ""),
    fechaFinPedido: params.fechaFinPedido.replace(/-/g, ""),
  }).toString();

  const response = await api().get(
    `/orden${!!queryParams ? "?" + queryParams : ""}`
  );

  return response.data.result.data;
};

export async function getEventsByOrderId(query) {
  console.log(query);

  const queryParams = new URLSearchParams({
    id: query.id,
    posicion: query.posicion /*'749575-1-39' */,
  }).toString();

  const response = await api().get(
    `/orden/eventos${!!queryParams ? "?" + queryParams : ""}`
  );
  return response.data.result.data;
}

export async function updateOrder(payload) {
  const response = await api().put(
    `/orden`,
    payload
  );
  return response.data.result;
}

